import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConsumerEdit, UserProfile } from '@usheru-hff/shared/domain';
import { UsheruApi } from '@usheru-hff/shared/data-access-backend';
import { BehaviorSubject, Observable, map, of, tap } from 'rxjs';
import { ENVIRONMENT, Environment } from '@environment';
import { AuthService } from '@usheru-hff/authentication/domain';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private userProfileSubject = new BehaviorSubject<UserProfile | null>(null);
  userProfile$ = this.userProfileSubject.asObservable();

  isUserLoggedSig = toSignal(this.authService.$userStatus.pipe(map(user => !!user)));

  constructor(
    @Inject(ENVIRONMENT) private env: Environment,
    private usheruApi: UsheruApi,
    private authService: AuthService,
    private http: HttpClient
  ) {}

  getUserProfile(username: string): Observable<UserProfile> {
    const headers = this.isUserLoggedSig()
      ? this.usheruApi.generateBearerHeader(this.authService?.accessToken())
      : this.usheruApi.getStandardHeader();
    // timestamp is used to avoid caching
    const params = this.usheruApi.filterToParams({ username: username.toLowerCase() });
    return this.http
      .get<UserProfile>(`${this.env.api?.url}/user-actions/profile/`, {
        headers,
        params
      })
      .pipe(
        tap(userProfile => {
          this.updateUserProfile(userProfile);
        })
      );
  }

  private isUserOwnProfile(username: string): boolean {
    return this.isUserLoggedSig() && this.authService.$userStatus.value?.username === username;
  }

  private updateUserProfile(userProfile: UserProfile) {
    this.userProfileSubject.next(userProfile);
  }

  checkUsername(username: string): Observable<boolean> {
    // TODO: implement this method
    const usernames = [
      'usheru',
      'usheru1',
      'usheru2',
      'usheru3',
      'usheru4',
      'usheru5',
      'usheru6',
      'usheru7',
      'usheru8',
      'usheru9'
    ];
    if (usernames.includes(username)) {
      return of(true);
    } else {
      return of(false);
    }
  }

  editNotifications(notifications: any): Observable<any> {
    // TODO: implement this method
    return of(true);
  }

  editProfile(consumer: ConsumerEdit): Observable<UserProfile> {
    const body = { ...consumer };
    return this.http
      .put<UserProfile>(`${this.env.api?.url}/user-actions/profile/`, body, {
        headers: this.usheruApi.generateBearerHeader(this.authService?.accessToken())
      })
      .pipe(tap(userProfile => this.updateUserProfile(userProfile)));
  }
}
